// extracted by mini-css-extract-plugin
export var contrastLow = "_r-1";
export var externalLink = "_r-2";
export var externalLinkIcon = "_r-3";
export var link = "_r-0";
export var linkLabel = "_r-4";